import { JOBS_RETRIED_EVENT } from "../../types";
import { request as utilsRequest } from "../../utils";
import { locationRestJobsSkipPost } from "../../wp-api";
import { fetchStatus } from "..";
/**
 * Skip jobs by e.g. type.
 */ async function skipJobs(request) {
    const response = await utilsRequest({
        location: locationRestJobsSkipPost,
        request
    });
    document.dispatchEvent(new CustomEvent(JOBS_RETRIED_EVENT, {
        detail: {
            request,
            response
        }
    }));
    await fetchStatus(true);
}
export { skipJobs };
